import type React from 'react';

import { DeleteIcon } from '@vlabs/icons';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button';
import { Button } from '@vlabs/uikit/components/controls/button';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { confirmDeleteStreams } from './confirm/confirmDeleteStreams';
import { useDeleteStreams } from './useDeleteStreams';
import { useDeleteStreamTranslation } from '../i18n';
import type { DeleteStreamsProps } from '../types';

const displayName = 'DeleteStreamsButton';
const testid = buildTestid(displayName);

interface DeleteStreamsButtonProps extends DeleteStreamsProps, WithDataTestid, ButtonProps {}

function DeleteStreamsButton({
  streamIds,
  onSuccess = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: DeleteStreamsButtonProps): React.JSX.Element {
  const { t } = useDeleteStreamTranslation();
  const { onDelete } = useDeleteStreams({ streamIds, onSuccess });

  return (
    <Button
      icon={<DeleteIcon />}
      kind="negative"
      onClick={() => confirmDeleteStreams({ onConfirm: onDelete })}
      variant="outlined"
      {...testid(dataTestId)}
      {...props}
    >
      {t('title')}
    </Button>
  );
}

DeleteStreamsButton.displayName = displayName;

export { DeleteStreamsButton };
